import React from 'react'
import { observer } from 'mobx-react-lite'

import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'

import { ChevronRight } from '@mxenabled/mx-icons'

import { Text } from '@mxenabled/mxui'

import { Dialog, useGlobalCopyStore } from '../'

interface ListItemActionProps {
  children?: React.ReactNode
  isDisabled?: boolean
  isSaveDisabled?: boolean
  label: string
  onCancel?: () => void
  onSave: () => void
  primaryText: string
  secondaryText: string
  zeroStateText?: string
}

export const ListItemAction = observer(
  ({
    children,
    isDisabled = false,
    isSaveDisabled = false,
    label,
    onCancel,
    onSave,
    primaryText,
    secondaryText,
    zeroStateText,
  }: ListItemActionProps) => {
    const { common: copy } = useGlobalCopyStore()

    const [isOpen, setIsOpen] = React.useState(false)

    const handleCancel = () => {
      setIsOpen(false)
      onCancel?.()
    }

    const handleSave = () => {
      setIsOpen(false)
      onSave()
    }

    return (
      <ListItem>
        <ListItemButton onClick={() => setIsOpen(!isDisabled)}>
          <ListItemText
            primary={
              <Stack alignItems="center" direction="row" justifyContent="space-between">
                <Text variant="body1">{primaryText}</Text>
                <Text
                  bold={true}
                  color={zeroStateText ? 'primary.main' : 'text.primary'}
                  sx={{ mr: 4 }}
                  variant="body1"
                >
                  {zeroStateText || secondaryText}
                </Text>
              </Stack>
            }
            slotProps={{ primary: { variant: 'body1' } }}
          />
          {!isDisabled && !zeroStateText && <ChevronRight />}
        </ListItemButton>
        <Dialog
          copy={{ title: label, close_aria: copy.close_aria }}
          disablePrimaryButton={isSaveDisabled}
          isOpen={isOpen}
          onClose={handleCancel}
          onPrimaryAction={handleSave}
          primaryText={copy.save_button}
        >
          {children}
        </Dialog>
      </ListItem>
    )
  },
)
